<!-- 联系我们 -->
 <template>
  <div>
    <div class="right-item-content">
      <div>公司名称:河南锦汇信息科技有限公司</div>
      <div style="margin-top: 20px">
        公司地址:河南省自贸试验区（郑东）金水东路85号2号楼312室
      </div>
    </div>
    <div class="right-item-content">
      <div>客服热线:18236414232</div>
      <div style="margin-top: 20px">客服微信:zin183399</div>
      <div style="margin-top: 20px">邮箱:2262334912@qq.com</div>
    </div>
  </div>
</template>

 <script>
export default {};
</script>

 <style lang="scss" scoped>
.right-item-content {
  margin-top: 10px;
  padding: 20px;
  color: #000000e0;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  background: #f8f8fa;
  border-radius: 8px;
}
</style>
